import { useContext } from 'react'
import { OldThemeContext } from '../context/themeContext'

export const useTheme = () => useContext(OldThemeContext)
